import AuditLogTemplate from "../../components/5templates/AuditLogTemplate";

const AuditLog = () => {
    return <AuditLogTemplate />;
};

export default AuditLog;
